import { render, staticRenderFns } from "./createDispatch.vue?vue&type=template&id=33b13100&scoped=true"
import script from "./createDispatch.vue?vue&type=script&lang=js"
export * from "./createDispatch.vue?vue&type=script&lang=js"
import style0 from "./createDispatch.vue?vue&type=style&index=0&id=33b13100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b13100",
  null
  
)

export default component.exports